<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="list"
      item-key="id"
      show-expand
      class="elevation-0 data-table"
    >
      <template v-slot:body="{ items }">
        <tbody v-for="item in items" :key="item.id">
          <tr class="data-table__row">
            <td />
            <td>
              {{ item.title }}
            </td>
            <td>
              {{ item.report_category_titleize }}
            </td>
            <td>
              <v-icon v-if="item.unavailable_for_payments" size="14"
                >$check_bold</v-icon
              >
            </td>
            <td>
              <v-icon v-if="item.unavailable_for_profiles" size="14"
                >$check_bold</v-icon
              >
            </td>

            <td class="text-center nowrap">
              <Actions
                hide-duplicate
                :path="`/specialties/${item.id}`"
                @destroy="$emit('destroy', item)"
              >
              </Actions>
            </td>
          </tr>
        </tbody>
      </template>
    </v-data-table>
  </div>
</template>

<script>
export default {
  props: {
    list: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    headers() {
      return [
        {
          text: "Title",
          align: "start",
          value: "title",
        },
        {
          text: "Report Category",
          align: "start",
          value: "report_category",
        },
        {
          text: "Unavailable for Payments",
          align: "start",
          value: "unavailable_for_payments",
        },
        {
          text: "Unavailable for Profiles",
          align: "start",
          value: "unavailable_for_profiles",
        },
        {
          text: "Actions",
          align: "center",
          sortable: false,
        },
      ];
    },
  },
};
</script>

<style>
.env-production .v-icon {
  color: white;
}
</style>
